import { render, staticRenderFns } from "./PhotographyBannerSection.vue?vue&type=template&id=3336b2eb"
import script from "./PhotographyBannerSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyBannerSection.vue?vue&type=style&index=0&id=3336b2eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports